// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30StorageProtect = '30C0R';

// Product Title & page url for creating CIs
export const productTitle = 'Storage Protect Calculator';
export const pageUrl = '/products/storage-protect-for-cloud/pricing';
export const pageTitle = 'Storage Protect Cloud Pricing Page';
export const object = 'Storage Protect for Cloud';
export const location = 'Pricing Page';
